import {Action} from "@ngrx/store";
import {BandwidthData} from "../../websites/website/booster/mappers/cloudflare/bandwidth";

export const LOAD_WEBSITE_BANDWIDTH: string = '[redirect] Load Website Bandwidth Data';
export const LOAD_WEBSITE_BANDWIDTH_SUCCESS: string = '[redirect] Load Website Bandwidth Data Success';
export const LOAD_WEBSITE_BANDWIDTH_FAIL: string = '[redirect] Load Website Bandwidth Data Fail';

export class LoadWebsiteBandwidth implements Action {
  readonly type: string = LOAD_WEBSITE_BANDWIDTH;
  constructor(public payload: number) {}
}

export class LoadWebsiteBandwidthSuccess implements Action {

  readonly type: string = LOAD_WEBSITE_BANDWIDTH_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    entities: BandwidthData,
  }) {}

}

export class LoadWebsiteBandwidthFail implements Action {

  readonly type: string = LOAD_WEBSITE_BANDWIDTH_FAIL;
  constructor(public payload: string) {}

}


export type BandwidthAction = LoadWebsiteBandwidth | LoadWebsiteBandwidthSuccess | LoadWebsiteBandwidthFail;
